import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { NavBarCollapsible } from 'bootstrap-italia';
import { KeycloakService } from 'keycloak-angular';
import { from } from 'rxjs';
import { UserRoles } from 'src/app/auth/auth.model';
import { RoleService } from '@shared/services/role/role.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  userRoles = UserRoles;

  isAuth: boolean = false;

  @ViewChild('navCollapsible')
  navCollapsibleRef!: ElementRef;

  role: string = '';
  roleID: string = '';

  private navCollapsible?: NavBarCollapsible;

  constructor(
    private titleService: Title,
    private translate: TranslateService,
    private router: Router,
    private keycloakSrv: KeycloakService,
    private roleService: RoleService
  ) {}

  ngOnInit(): void {
    this.setUserAuth();
    this.setRoleAndRoleID();
  }

  clearFocus(item: HTMLElement) {
    item.blur();
    this.navCollapsible?.hide();
  }

  toggleNavbar() {
    this.navCollapsible = new NavBarCollapsible(
      this.navCollapsibleRef.nativeElement
    );
    this.navCollapsible.toggle(this.navCollapsibleRef.nativeElement);
  }

  changeTitle(title: any) {
    this.titleService.setTitle(
      this.translate.instant(title) +
        ' | ' +
        this.translate.instant('PORTALE_FORMAZIONE') +
        ' ' +
        this.translate.instant('REG_ABRUZZO')
    );
  }

  isExactRoute(url: string) {
    return this.router.url === url;
  }

  isCurrentRoute(url: string) {
    return this.router.url.startsWith(url);
  }

  setUserAuth() {
    from(this.keycloakSrv.isLoggedIn()).subscribe((auth) => {
      this.isAuth = auth;
    });
  }

  setRoleAndRoleID() {
    this.roleService.ruoloAttuale.subscribe((ruoloAttuale: string) => {
      switch (ruoloAttuale) {
        case this.userRoles.CPI:
          this.role = 'cpi';
          this.roleID = this.userRoles.CPI;
          break;
        case this.userRoles.ENTE:
          this.role = 'ente';
          this.roleID = this.userRoles.ENTE;
          break;
        case this.userRoles.REGIONE:
          this.role = 'regione';
          this.roleID = this.userRoles.REGIONE;
          break;
        case this.userRoles.DOCENTE:
          this.role = 'docente';
          this.roleID = this.userRoles.DOCENTE;
          break;
        case this.userRoles.CITTADINO:
          this.role = 'cittadino';
          this.roleID = this.userRoles.CITTADINO;
          break;
        case this.userRoles.PRESIDENTE:
          this.role = 'presidente';
          this.roleID = this.userRoles.PRESIDENTE;
          break;
        case this.userRoles.TUTOR:
          this.role = 'tutor';
          this.roleID = this.userRoles.TUTOR;
          break;
        default:
          this.role = '';
          this.roleID = '';
      }
    });
  }
}
